import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { pick } from 'ramda'

import { breakpoints } from '@/styles'
import { initializeApollo } from '@/lib/apollo'
import { getListingsData, withCitiesQueryRedirect } from '@/lib/listings'
import { initializeStore } from '@/lib/redux'
import { makeMainLayout } from '@/layouts/main'
import ListingsMap from '@/features/ListingsMap'

const headerConfig = {
  showSearch: true
}
const footerConfig = {
  hideOnBreakpoint: breakpoints.ipadMiniMax
}
const supportConfig = {
  enabled: false
}

const selectFromState = pick(['listings'])

const RentalListings = () => <ListingsMap setFilterDefaultCity={false} />

export const getServerSideProps = async ({ req, query, locale }) => {
  const apolloClient = initializeApollo()
  const reduxStore = initializeStore()
  const { redirect } = withCitiesQueryRedirect({ query })

  if (redirect) return { redirect }

  await getListingsData({
    reduxStore,
    apolloClient,
    query,
    req,
    filtersOverride: {
      cities: null
    }
  })

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      initialReduxState: selectFromState(reduxStore.getState()),
      ...(await serverSideTranslations(locale, [
        'translation',
        'seo',
        'states',
        'cities',
        'filters'
      ]))
    }
  }
}

RentalListings.Layout = makeMainLayout({
  headerConfig,
  footerConfig,
  supportConfig,
  disableZoom: true
})

export default RentalListings
